import en from './en'
import te from './te'
import ta from './ta'
import kn from './kn'
import mr from './mr'

export default {
  en,
  te,
  ta,
  kn,
  mr
}
